import { render, staticRenderFns } from "./DefaultField.vue?vue&type=template&id=f9012bfe&"
import script from "./DefaultField.vue?vue&type=script&lang=js&"
export * from "./DefaultField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports